import { useState } from "react"
import type { SignInContextType } from "accounts/contexts/SignIn"
import { Tabs } from "accounts/domain"

const useSignIn = (): SignInContextType => {
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false)
  const [nextLocation, setNextLocation] = useState<string>()
  const [initialTab, setInitialTab] = useState<Tabs>(Tabs.SignIn)

  const openSignInModal = (tab: Tabs = Tabs.SignIn) => {
    setInitialTab(tab)
    setIsSignInModalOpen(true)
  }

  const closeSignInModal = () => {
    setInitialTab(Tabs.SignIn)
    setIsSignInModalOpen(false)
  }

  return {
    isSignInModalOpen,
    openSignInModal,
    closeSignInModal,
    nextLocation,
    setNextLocation,
    initialTab
  }
}

export default useSignIn
